import React, { useState } from "react";

import ResetPasswordForm from "./ResetPasswordForm";
import { useParams } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { RESET_PASSWORD } from "./queries";
import LoadingOverlay from "react-loading-overlay";

export default function ResetPassword() {
  const { userId, resetToken } = useParams();
  const [loading, setLoading] = useState(false);
  const [resetPassword] = useMutation(RESET_PASSWORD);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState(undefined);

  function handleSubmit(password, passwordConfirm) {
    setLoading(true);

    resetPassword({
      variables: {
        newPassword: password,
        newPasswordConfirm: passwordConfirm,
        signedUserId: userId,
        resetToken: resetToken,
      },
    })
      .then(() => {
        setSuccess(true);
        setLoading(false);
      })
      .catch((e) => {
        setErrorMessage(e.graphQLErrors[0].message);
        setLoading(false);
      });
  }

  return (
    <div className="forgot-password-container">
      <LoadingOverlay active={loading} spinner text="Resetting password...">
        {!success ? (
          <>
            <h1 className="forgot-password-header">Reset Password</h1>
            <div className="forgot-password-form-container">
              <ResetPasswordForm
                onSubmit={handleSubmit}
                errorMessage={errorMessage}
              />
            </div>
          </>
        ) : (
          <div className="forgot-password-submitted">
            <p>Your password has successfully been reset.</p>
            <p>
              Click <a href="/login">here</a> to login.
            </p>
          </div>
        )}
      </LoadingOverlay>
    </div>
  );
}
